module.exports = __webpack_public_path__ + "static/img/checkmark.2466ed96.svg";